import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filterType: {
    status: "",
    relatedRefundBranch: "",
    startDate: "",
    endDate: "",
  },
  keyword: "",
  page: 1,
  limit: 10,
};
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterType: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSearch: (state, action) => {
      state.keyword = action.payload;
    },
    clearFilter: (state) => {
      state.filterType = {
        status: "",
        relatedRefundBranch: "",
        startDate: "",
        endDate: "",
      };
      state.page = 1;
      state.limit = 10;
    },
  },
});

export const { setPage, setLimit, setFilterType, clearFilter, setSearch } =
  filterSlice.actions;
export default filterSlice.reducer;
